import {mapValueKeys} from '@shared/helpers/object'

import makeSlice from '@web/slices/deliveryGroup/sliceMaker'

import {fetchDeliveryFee, fetchSubscription} from '../../actions'

import {convertDeliveryGroupsByKey} from './converter'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(fetchSubscription.fulfilled, (state, {payload: {subscriptionViewResult}}) => {
                const {delivery} = subscriptionViewResult
                state.deliveryGroupsByKey = convertDeliveryGroupsByKey(delivery.deliveryGroupsByKey)
            })
            .addCase(
                fetchDeliveryFee.fulfilled,
                (
                    state,
                    {
                        payload: {
                            delivery: {deliveryGroupsByKey},
                        },
                    },
                ) => {
                    state.deliveryGroupsByKey = mapValueKeys((deliveryGroup, key) => {
                        const recalculatedDeliveryGroup = deliveryGroupsByKey[key]

                        return {
                            ...deliveryGroup,
                            deliveryFee: recalculatedDeliveryGroup?.deliveryFee ?? deliveryGroup.deliveryFee,
                            additionalDeliveryFee:
                                recalculatedDeliveryGroup?.additionalDeliveryFee ?? deliveryGroup.additionalDeliveryFee,
                            deliveryFeePayType:
                                recalculatedDeliveryGroup?.deliveryFeePayType ?? deliveryGroup.deliveryFeePayType,
                        }
                    }, state.deliveryGroupsByKey)
                },
            )
    },
})

export default slice.reducer
